import Backbone from "backbone";
import * as mustcache from "mustcache";
import * as _ from "underscore";

// model - RemoteUserWords
const SelectWholeCollectionView = Backbone.View.extend({
  initialize: function () {
    const that = this;

    this.listenTo(this.model, "change:wholeCollection", () => {
      console.log("changed wholeCollection select");
      that.render();
    });
    this.listenTo(this.model, "change:wholePage", () => {
      that.render();
    });
  },
  render: function () {
    if (
      this.model.get("wholePage") &&
      this.model.getTotalCount() > this.model.getPageCount()
    ) {
      const templateData = _.extend(this.model.toJSON(), {
        pageCount: this.model.getPageCount(),
        totalCount: this.model.getTotalCount(),
      });
      this.$el.html(mustcache.render("selectWholeCollection", templateData));
      this.$el.show();
    } else {
      this.$el.hide();
    }
  },
  events: {
    'click a[data-action="selectAll"]': "selectAll",
    'click a[data-action="clearSelection"]': "clearSelection",
  },
  selectAll: function (event) {
    event.preventDefault();
    event.stopPropagation();

    this.model.selectWholeCollection();
  },
  clearSelection: function (event) {
    event.preventDefault();
    event.stopPropagation();

    this.model.clearSelection();
  },
});

export default SelectWholeCollectionView;
